var REG_IMG_URL = /^(?:(?:http|https):)?\/\/(ossgw\.(?:alicdn|taobaocdn|taobao)\.(?:com|net))(\/.*(?:\.(jpg|png|gif|jpeg|webp))?)$/i;
export default function (url) {
  return url.match(REG_IMG_URL);
}